import { StepStatus } from '../config/CustomEnums';
export const defaultStep = (nameList) =>
  nameList.map((name, index) => {
    return {
      name: name,
      status: index === 0 ? StepStatus.processing : StepStatus.waiting,
      active: index === 0,
      finished: false,
    };
  });

export function getNewStepConfig(
  currentStep,
  oldConfig,
  error,
  isBack = false,
) {
  if (error) {
    oldConfig[currentStep].status = StepStatus.error;
    return oldConfig;
  }
  oldConfig[currentStep].status = StepStatus.finished;
  oldConfig[currentStep].active = true;
  if (isBack) {
    oldConfig[currentStep - 1].status = StepStatus.processing;
    if (!oldConfig[currentStep].finished) {
      oldConfig[currentStep].status = StepStatus.waiting;
      oldConfig[currentStep].active = false;
    }
  } else if (currentStep === oldConfig.length - 1) {
    oldConfig[currentStep].finished = true;
    oldConfig[currentStep].active = true;
  } else {
    oldConfig[currentStep].finished = true;
    oldConfig[currentStep + 1].status = StepStatus.processing;
    oldConfig[currentStep + 1].active = true;
  }
  return oldConfig;
}

export const defaultStepV2 = ({
  nameList,
  hideFirstStep,
}) => {
  return nameList.map((name, index) => {
    return {
      name: name,
      active: index === 0,
      hide: hideFirstStep && index === 0,
    };
  })
};

export const getNewStepConfigV2 = ({
  newStep,
  oldConfig,
}) => {
  const newConfig = oldConfig?.map((step, index) => {
    if (index === newStep) {
      step["active"] = true;
    } else {
      step["active"] = false;
    }
    return step
  })
  return newConfig;
};
